// src/pages/customer/customerwidgets/OrderRow.jsx
import React from 'react';

const STATUS_STYLES = {
  delivered: 'text-emerald-600 bg-emerald-50',
  pending:   'text-amber-600 bg-amber-50',
  cancelled: 'text-red-600 bg-red-50',
  confirmed: 'text-blue-600 bg-blue-50',
  completed: 'text-emerald-600 bg-emerald-50',
};

const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return `http://localhost:4000${url}`;
};

export default function OrderRow({ order }) {
  const { id, animal_name, status, amount, image_url, category } = order;
  const style = STATUS_STYLES[status?.toLowerCase()] || 'text-secondary bg-surface-container';

  return (
    <div className="flex items-center justify-between py-3 border-b
                    border-outline-variant/10 last:border-0">
      <div className="flex items-center gap-3">
        {/* Image */}
        <div className="w-11 h-11 rounded-xl overflow-hidden bg-surface-container
                        flex-shrink-0 flex items-center justify-center">
          {image_url
            ? <img src={getImageUrl(image_url)} alt={animal_name}
                   className="w-full h-full object-cover" />
            : <span className="material-symbols-outlined text-[20px] text-outline">pets</span>
          }
        </div>

        {/* Name + ID */}
        <div>
          <p className="text-sm font-bold text-on-surface">{animal_name || '—'}</p>
          <p className="text-[10px] text-secondary">
            Order #{id} {category ? `· ${category}` : ''}
          </p>
        </div>
      </div>

      {/* Amount + Status */}
      <div className="flex items-center gap-4">
        <p className="text-sm font-bold text-on-surface">
          ₹{Number(amount || 0).toLocaleString('en-IN')}
        </p>
        <span className={`text-[10px] font-black px-2 py-1 rounded-full capitalize ${style}`}>
          {status}
        </span>
      </div>
    </div>
  );
}